import { render } from "./DropdownStockByGroup.vue?vue&type=template&id=a7e27fc8"
import script from "./DropdownStockByGroup.vue?vue&type=script&lang=ts"
export * from "./DropdownStockByGroup.vue?vue&type=script&lang=ts"
script.render = render

export default script